import React from "react";

export const Navigation = (props) => {
  const nav = props.ui ? props.ui.nav : {};
  const otherLanguage = props.language === "en" ? "es" : "en";

  const handleLanguageToggle = (e) => {
    e.preventDefault();
    if (props.onLanguageChange) props.onLanguageChange(otherLanguage);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Tree of light
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                {nav.features || "Features"}
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                {nav.about || "About"}
              </a>
            </li>
            {/* <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li> */}
            <li>
              <a href="#portfolio" className="page-scroll">
                {nav.gallery || "Gallery"}
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            {/* <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                {nav.contact || "Contact"}
              </a>
            </li>
            <li>
              <a
                href="#page-top"
                className="page-scroll"
                onClick={handleLanguageToggle}
              >
                <i className="fa fa-language"></i>{" "}
                {(props.ui && props.ui.languageName) || "Español"}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
